import React from 'react'
import { Title, Subtitle } from '../../title/title.jsx'
export function BaseForm(props) {
  const { isSubmitted, isSuccess, headline, subtitle, children } = props
  const strings = {
    title: 'Send us a message',
    subtitle:
      'All fields are required. Please do not include personal information such as account numbers, Social Security numbers or taxpayer numbers in your email.',
    thankYou: 'Thank you for submitting your message',
    teamResonse: 'Our team will respond as soon as possible.',
    formId: 'BaseForm',
    tryAgainLater:
      'Your message could not be submitted at this time. Please try again later.',
    technicalDifficulties: "We're experiencing technical difficulties.",
  }

  const Failure = (
    <div className="u-flex u-flexAlignItemsCenter u-bgColorWhite u-border u-borderColorNeutralLight u-marginVert4gu u-padding3gu">
      <span className="Icon--material u-marginRight2gu u-textColorAlert u-textSizeMsrp3">
        error_outline
      </span>
      <div className="u-textSizeMsrm1 u-textColorLight">
        <span className="u-textBold u-textSecondary">
          {strings.technicalDifficulties}
        </span>
        {strings.tryAgainLater}
      </div>
    </div>
  )

  const Success = (
    <div className="u-flex u-flexCol u-flexAlignItemsCenter u-marginTop5gu u-padding15gu u-bgColorWhite">
      <div>
        <span
          className="Icon--material u-textColorAdele u-textSizeMsrp5"
          aria-hidden="true"
        >
          check_circle
        </span>
      </div>
      <h4 className="u-textColorBrand u-textSizeMsrp3">{strings.thankYou}</h4>
      <div className="u-marginTop2gu u-textSizeMsrp1">
        {strings.teamResonse}
      </div>
    </div>
  )
  let formContent;
  if (!isSubmitted) {
    formContent = <Title text={strings.title} mode={'medium'} />;
  } else if (isSuccess) {
    formContent = Success;
  } else {
    formContent = Failure;
  }

  return (
    <>
      {headline || null}
      <div className="u-posRelative u-bgColorLight u-paddingVert10gu">
        <div className="u-sizeConstrained">
          {formContent}
          {!isSubmitted && (
            <>
              <Subtitle text={subtitle || strings.subtitle} mode="medium" />
              {children}
            </>
          )}
        </div>
      </div>
    </>
  )
}
